import { render, staticRenderFns } from "./layout-container.vue?vue&type=template&id=4516ef43&"
import script from "./layout-container.vue?vue&type=script&lang=js&"
export * from "./layout-container.vue?vue&type=script&lang=js&"
import style0 from "./layout-container.vue?vue&type=style&index=0&id=4516ef43&prod&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports